import React, { useContext } from 'react';
import { FailedTwinsContext } from './FailedToSent';
import { Table, TableBody, TableHeader, TableHeaderColumn, TableRow } from 'material-ui';
import FailedToSentRow from './FailedToSentRow';
import styled from 'styled-components';

export default function FailedToSentTable({ sendRequest }) {
    const { failedTwins } = useContext(FailedTwinsContext);

    return (
        <Table 
            fixedHeader
            selectable={false}
        >
            <TableHeader
                displaySelectAll={false} 
                adjustForCheckbox={false}
            >
                <TableRow>
                    <StyledTableHeaderColumn width={34}>
                        Subject
                    </StyledTableHeaderColumn>
                    <StyledTableHeaderColumn width={5}>
                        Link
                    </StyledTableHeaderColumn>
                    <StyledTableHeaderColumn width={15}>
                        Broker Email
                    </StyledTableHeaderColumn>
                    <StyledTableHeaderColumn width={15}>
                        Real User Email
                    </StyledTableHeaderColumn>
                    <StyledTableHeaderColumn width={15}>
                        Result refNos
                    </StyledTableHeaderColumn>
                    <StyledTableHeaderColumn width={5} pl={12} pr={12}>
                        Status
                    </StyledTableHeaderColumn>
                    <StyledTableHeaderColumn width={11}>
                        Management
                    </StyledTableHeaderColumn>
                </TableRow>
            </TableHeader>
            <TableBody displayRowCheckbox={false}>
                { failedTwins.map((item, index) => (
                    <TableRow key={`failedTwin_${index}`}>
                        <FailedToSentRow 
                            key={`failedTwin_${index}`} 
                            itemIndex={index}
                            item={item}
                            sendRequest={sendRequest}
                        />
                    </TableRow>
                ))
                }
            </TableBody>
        </Table>
    );
}

export const StyledTableHeaderColumn = styled(TableHeaderColumn)`
    width: ${props => props.width + '%'};
    padding-left: ${props => props.pl + 'px'} !important;
    padding-right: ${props => props.pr + 'px'} !important;
`;




// WEBPACK FOOTER //
// ./app/components/Letters/common/FailedToSentTable.jsx